import React from 'react'
import './Background.css'

const Messages = () => {
    return (
        <div>
            <div className='background-message right'><p>Mock text</p></div>
            <div className='background-message left hidden'><p>Mock text</p></div>
            <div className='background-message left'><p>Mock text</p></div>
            <div className='background-message right'><p>Mock text</p></div>
            <div className='background-message left hidden'><p>Mock text</p></div>
            <div className='background-message right'><p>Mock text</p></div>
            <div className='background-message left hidden'><p>Mock text</p></div>
            <div className='background-message left'><p>Mock text</p></div>
            <div className='background-message right'><p>Mock text</p></div>
            <div className='background-message left hidden'><p>Mock text</p></div>
            <div className='background-message left'><p>Mock text</p></div>
        </div>
    )
}

export default Messages